import GatherDataBreadcrumbs from './GatherDataBreadcrumbs';

export default GatherDataBreadcrumbs;
